module.exports = function(obj) {
obj || (obj = {});
var __t, __p = '', __e = _.escape, __j = Array.prototype.join;
function print() { __p += __j.call(arguments, '') }
with (obj) {
__p += '<div class="supported-browsers-inner">\n    <div class="main-logo"></div>\n\n    <h2>Browser Support</h2>\n\n    <div class="supported-browsers-list">\n\n        <h3>You are using an unsupported browser - performance and correctness may suffer!</h3>\n        <p>We recommend the following browsers in order of priority:<br><br></p>\n\n        <div class="pull-left">\n            <b><u>Windows</u>:</b>\n            <b>Microsoft Internet Explorer 11</b>\n            <p>(Drag\'n Drop Bookmarklet not supported)</p>\n            <b>Chrome, latest version</b>\n            <p>(See Creator Community on how to use Drag\'n Drop Bookmarklet)</p>\n            <b>Firefox, <span>latest version</span></b>\n        </div>\n\n        <div class="pull-right">\n            <b><u>Mac OS X</u>:</b>\n            <b>Safari, <span>latest version</span></b>\n            <p>(Drag\'n Drop Bookmarklet not supported)</p>\n            <b>Chrome, latest version</b>\n            <p>(Drag\'n Drop Bookmarklet not supported)</p>\n            <b>Firefox, <span>latest version</span></b>\n        </div>\n    </div>\n\n    <a href="#" class="back-to-sign-in">&lt; Back to Login Page</a>\n\n    ';
 if (config.supportEmail) { ;
__p += '\n        <div class="support-link">\n            <a href="mailto:' +
__e(config.supportEmail) +
'">' +
__e(config.supportEmail) +
'</a>\n        </div>\n    ';
 } ;
__p += '\n</div>\n';

}
return __p
}


//////////////////
// WEBPACK FOOTER
// ./src/editor/ui/user/BrowserSupportView.tpl
// module id = 2801
// module chunks = 0